import { render, staticRenderFns } from "./DiermocratieSlide.vue?vue&type=template&id=fcb4115c"
import script from "./DiermocratieSlide.vue?vue&type=script&lang=js"
export * from "./DiermocratieSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports